export default{
    cadastra:{
        method:'post',
        url:'tomador/backup'
    },
}